// screen: Help center — a manual topic (section in the URL hash)
import { createFileRoute } from '@tanstack/react-router';
import { HelpCenter } from '~/help/HelpCenter';

export const Route = createFileRoute('/_layout/t/$slug/help/$topic')({ component: Screen });

function Screen() {
  const { slug, topic } = Route.useParams();
  return <HelpCenter slug={slug} topicId={topic} />;
}
